<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-cash-multiple"></i>
                <h2>Relação de Valores</h2>
              </div>
            </div>
          </div>
          <div class="row" v-if="loading">
            <div class="sm-12">
              <p class="text-center">
                <i class="mdi mdi-loading mdi-spin mdi-48px"></i>
              </p>
            </div>
          </div>
          <div v-else>
            <form @submit.prevent.stop="filtrar">
              <div class="row">
                <div class="sm-12 md-6 lg-2">
                  <label>
                    Ano
                    <select v-model="ano">
                      <option v-for="ano in anos" :value="ano" :key="ano">
                        {{ ano }}
                      </option>
                    </select>
                  </label>
                </div>
                <div class="sm-12 md-6 lg-2">
                  <label>
                    Mês
                    <select v-model="mes">
                      <option v-for="m in 12" :value="m" :key="m">
                        {{ meses[m] }}
                      </option>
                    </select>
                  </label>
                </div>
                <div class="sm-12 md-6 lg-2" v-if="blocos.length != 0">
                  <label>
                    Bloco
                    <select v-model="codigo_bloco">
                      <option value>Bloco</option>
                      <option
                        v-for="bloco in blocos"
                        :key="bloco.codigo"
                        :value="bloco.codigo">
                        BLOCO {{ bloco.codigo }}
                      </option>
                    </select>
                  </label>
                </div>
                <div class="sm-12 md-6 lg-3" v-if="unidades.length != 0">
                  <label>
                    Unidade
                    <select v-model="codigo_unidade">
                      <option value>Unidade</option>
                      <option
                        :value="unidade.codigo"
                        v-for="unidade in unidades"
                        :key="unidade.codigo">
                        {{ unidade.descricao }}
                      </option>
                    </select>
                  </label>
                </div>
                <div class="sm-12 md-6 lg-3">
                  <label>
                    <br />
                    <button class="button secondary">Gerar extrato</button>
                  </label>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="sm-12">
                <p>
                  <strong>ATENÇÃO:</strong> Ao utilizar os filtros bloco e/ou
                  unidade os valores apresentados serão apenas dos dados
                  selecionados.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="sm-12 md-6">
                <p>
                  <strong>Dados Gerais</strong>
                </p>
              </div>
              <div
                class="sm-12 md-6 text-right"
                style="
                  display: grid;
                  gap: 10px;
                  grid-template-columns: 1fr 1fr;
                ">
                <button
                  class="button secondary print-button visible-md"
                  @click="print">
                  Imprimir
                </button>
                <button
                  class="button secondary visible-md"
                  @click="exportToExcel">
                  Exportar para Excel
                </button>
              </div>
            </div>
            <div class="row" v-if="dadosCondominio">
              <div class="sm-12">
                <div class="reponsive-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Condomínio</th>
                        <th>Endereço</th>
                        <th align="center">Dia do Vencimento</th>
                        <th>Multa</th>
                        <th>Unidades</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ dadosCondominio.Nome }}</td>
                        <td>{{ dadosCondominio.Endereco }}</td>
                        <td align="center">
                          {{ dadosCondominio.DiaVencimento }}
                        </td>
                        <td>{{ dadosCondominio.Multa }}</td>
                        <td>{{ dadosCondominio.Unidades }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row" v-if="Docs.length">
              <div class="sm-12">
                <p>
                  <strong>Relação de Valores</strong>
                </p>
              </div>
            </div>

            <div class="row" v-if="Docs.length != 0">
              <div class="sm-12">
                <div class="responsive-table">
                  <table class="table-docs table-values">
                    <thead>
                      <tr>
                        <th>Unidade</th>
                        <th width="140" align="center">Vencimento</th>
                        <th width="140" align="center">Código</th>
                        <th>Descrição</th>
                        <th width="140" align="right">Valor</th>
                      </tr>
                    </thead>
                    <tbody v-for="doc in Docs" :key="doc.id">
                      <tr
                        v-for="(receita, index) in doc.Receitas"
                        :key="receita.CodReceita">
                        <td
                          valign="top"
                          v-if="index == 0"
                          :rowspan="doc.Receitas.length + 2">
                          {{ doc.Unidade }}
                          <div v-if="doc.TipoDOC == 'G'">
                            <br />
                            * DOC Agrupado:
                            {{ doc.UnidadeAgrupada }}
                          </div>
                        </td>
                        <td
                          valign="top"
                          align="center"
                          v-if="index == 0"
                          :rowspan="doc.Receitas.length + 2">
                          {{ doc.DataVencimento | date("dd/LL/yyyy") }}
                        </td>
                        <td align="center">{{ receita.CodReceita }}</td>
                        <td>{{ receita.Descricao }}</td>
                        <td align="right">
                          {{ receita.Valor | number_format }}
                        </td>
                      </tr>
                      <tr>
                        <td align="right" colspan="2">
                          <b>TOTAL</b>
                        </td>
                        <td align="right">
                          {{ doc.ValorDOC | number_format }}
                        </td>
                      </tr>

                      <tr>
                        <td align="right" colspan="2">
                          <b>TOTAL COM MULTA</b>
                        </td>
                        <td align="right">
                          {{ doc.ValorComMulta | number_format }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div v-for="chamada in ChamadasExtras" :key="chamada.numero">
              <div class="row">
                <div class="sm-12">
                  <p>
                    <strong>Chamada Extra Número {{ chamada.numero }}</strong>
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="sm-12">
                  <div class="responsive-table">
                    <table class="table-docs">
                      <thead>
                        <tr>
                          <th>Unidade</th>
                          <th width="140" align="center">Vencimento</th>
                          <th width="140" align="center">Código</th>
                          <th>Descrição</th>
                          <th width="140" align="right">Valor</th>
                        </tr>
                      </thead>
                      <tbody v-for="doc in chamada.docs" :key="doc.id">
                        <tr
                          v-for="(receita, index) in doc.Receitas"
                          :key="receita.CodReceita">
                          <td
                            valign="top"
                            v-if="index == 0"
                            :rowspan="doc.Receitas.length + 2">
                            {{ doc.Unidade }}
                            <div v-if="doc.TipoDOC == 'G'">
                              <br />
                              * DOC Agrupado:
                              {{ doc.UnidadeAgrupada }}
                            </div>
                          </td>
                          <td
                            valign="top"
                            align="center"
                            v-if="index == 0"
                            :rowspan="doc.Receitas.length + 2">
                            {{ doc.DataVencimento | date("dd/LL/yyyy") }}
                          </td>
                          <td align="center">{{ receita.CodReceita }}</td>
                          <td>{{ receita.Descricao }}</td>
                          <td align="right">
                            {{ receita.Valor | number_format }}
                          </td>
                        </tr>
                        <tr>
                          <td align="right" colspan="2">
                            <b>TOTAL</b>
                          </td>
                          <td align="right">
                            {{ doc.ValorDOC | number_format }}
                          </td>
                        </tr>

                        <tr>
                          <td align="right" colspan="2">
                            <b>TOTAL COM MULTA</b>
                          </td>
                          <td align="right">
                            {{ doc.ValorComMulta | number_format }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="resumo">
              <div class="sm-12">
                <p>
                  <strong>Resumo</strong>
                </p>
              </div>
            </div>
            <div class="row" v-if="resumo">
              <div class="sm-12">
                <div class="responsive-table">
                  <table class="table-docs">
                    <thead>
                      <tr>
                        <th width="140" align="center">Código</th>
                        <th>Descrição</th>
                        <th width="140" align="right">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="receita in resumo.Receitas"
                        :key="receita.CodReceita">
                        <td align="center">{{ receita.CodReceita }}</td>
                        <td>{{ receita.Descricao }}</td>
                        <td align="right">
                          {{ receita.Valor | number_format }}
                        </td>
                      </tr>
                      <tr>
                        <td align="right" colspan="2">
                          <b>TOTAL</b>
                        </td>
                        <td align="right">
                          {{ resumo.ValorReceitas | number_format }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "/plugins/api";
//import ExcelJS from 'exceljs';
import { DateTime } from "luxon";
export default {
  data() {
    let data = new Date();
    let ano_atual = data.getFullYear();
    let mes_atual = data.getMonth() + 1;

    return {
      codigo_bloco: "",
      codigo_unidade: "",
      loading: false,
      errors: [],
      docs: [],
      dadosCondominio: null,
      resumo: null,
      ano: ano_atual,
      mes: mes_atual,
      ano_atual,
      mes_atual,
      meses: [
        "",
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  filters: {
    number_format(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  computed: {
    bloco() {
      if (this.codigo_bloco == "") {
        return "";
      }
      return `BLOCO ${this.codigo_bloco}`;
    },
    unidade() {
      if (this.codigo_unidade == "") {
        return "";
      }

      let unidade = this.unidades.find(u => u.codigo == this.codigo_unidade);
      if (!unidade) {
        return "";
      }

      return unidade.descricao;
    },
    blocos() {
      if ("undefined" === typeof this.condominio) {
        return [];
      }
      if ("undefined" === typeof this.condominio.blocos) {
        return [];
      }
      let blocos = this.condominio.blocos;
      if ("undefined" != typeof blocos.bloco) {
        blocos = blocos.bloco;
      }
      if (Object.values(blocos).length == 0) {
        blocos = [];
      }
      if (!(blocos instanceof Array)) {
        blocos = [blocos];
      }
      return blocos;
    },
    unidades() {
      if ("undefined" === typeof this.condominio) {
        return [];
      }
      if ("undefined" === typeof this.condominio.unidades) {
        return [];
      }
      let unidades = this.condominio.unidades;
      if (Object.values(unidades).length == 0) {
        return [];
      }
      if (!(unidades instanceof Array)) {
        unidades = [unidades];
      }
      if ("" != this.codigo_bloco) {
        unidades = unidades.filter(({ descricao }) => {
          let regex = new RegExp(`BLOCO ${this.codigo_bloco}$`, "igm");
          return regex.test(descricao);
        });
      }
      return unidades;
    },
    anos() {
      let anos = [];
      for (let ano = this.ano_atual; ano >= this.ano_atual - 100; ano--) {
        anos.push(ano);
      }
      return anos;
    },
    Docs() {
      return this.docs.filter(doc => {
        return doc.TipoDOC != "E" && doc.TipoDOCAgrupado != "E";
      });
    },
    ChamadasExtras() {
      let docs = this.docs.filter(doc => {
        return doc.TipoDOC == "E" || doc.TipoDOCAgrupado == "E";
      });
      let chamadas = docs.map(({ NumeroChamadaExtra }) => NumeroChamadaExtra);
      chamadas = [...new Set(chamadas)].map(numero => {
        let chamada = {
          numero,
          docs: docs.filter(doc => doc.NumeroChamadaExtra == numero),
        };
        return chamada;
      });
      return chamadas;
    },
    condominio() {
      return this.$store.getters.condominio;
    },
    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }
      return this.condominio.codigo;
    },
    imovel() {
      return this.$store.getters.imovel;
    },
    codigo_imovel() {
      if (!this.imovel) {
        return null;
      }
      return this.imovel.codigo;
    },
    relacao() {
      return this.$store.getters.relacao;
    },
    sistema() {
      return this.relacao.sistema;
    },
    tipo_relacao() {
      return this.relacao.tipoRelacao;
    },
  },
  methods: {
    print() {
      window.print();
    },
    async exportToExcel() {
      try {
        const Workbook = await import("exceljs").then(e => e.Workbook);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Dados Condomínio");

        // Adicione os cabeçalhos das colunas
        worksheet.addRow([
          "Condomínio",
          "Endereço",
          "Dia do Vencimento",
          "Multa",
          "Unidades",
        ]);

        // Adicione os dados do condomínio à planilha
        const { dadosCondominio } = this;
        worksheet.addRow([
          dadosCondominio.Nome,
          dadosCondominio.Endereco,
          dadosCondominio.DiaVencimento,
          dadosCondominio.Multa,
          dadosCondominio.Unidades,
        ]);

        worksheet.addRow([]);

        worksheet.addRow([
          "Unidade",
          "Vencimento",
          "Código",
          "Descrição",
          "Valor",
        ]);

        // Adicionar os dados da tabela table-docs à planilha
        const tableDocs = this.Docs;

        tableDocs.forEach(doc => {
          let unidadeExibida = false;
          let unidade = "";
          let vencimento = "";

          doc.Receitas.forEach((receita, index) => {
            if (index === 0 && !unidadeExibida) {
              unidade = doc.Unidade;
              unidadeExibida = true;
              vencimento = DateTime.fromISO(doc.DataVencimento).toFormat(
                "dd/LL/yyyy"
              );
            } else {
              unidade = "";
              vencimento = "";
              unidadeExibida = false;
            }
            worksheet.addRow([
              unidade,
              vencimento,
              receita.CodReceita,
              receita.Descricao,
              receita.Valor,
            ]);
          });

          worksheet.addRow(["", "", "TOTAL", "", doc.ValorDOC]);

          worksheet.addRow(["", "", "TOTAL COM MULTA", "", doc.ValorComMulta]);

          // Pular uma linha para separar as entradas de documento
          worksheet.addRow([]);
        });

        worksheet.addRow([]);

        worksheet.addRow(["Código", "Descrição", "Valor"]);

        const resumo = this.resumo;
        resumo.Receitas.forEach(receita => {
          worksheet.addRow([
            receita.CodReceita,
            receita.Descricao,
            receita.Valor,
          ]);
        });

        // Adicione a linha de total no resumo
        worksheet.addRow(["TOTAL", "", resumo.ValorReceitas]);

        // Salve o arquivo Excel
        const nomeMes = this.meses[this.mes];
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileName = `Relação_de_Valores_${nomeMes}_${this.ano}_(${this.condominio.abrev}) - ${this.condominio.nome}.xlsx`;

        // Crie um link temporário e clique nele para baixar o arquivo
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      } catch (error) {
        console.error("Erro ao exportar para Excel:", error);
        // Trate o erro conforme necessário
      }
    },
    async filtrar() {
      this.loadDocsCondominio();
    },
    async loadDocsCondominio() {
      try {
        if (this.sistema == "A") {
          return;
        }
        if (!this.codigo_condominio) {
          return;
        }
        this.docs = [];
        this.resumo = null;
        this.dadosCondominio = null;

        let params = {};
        if (this.condominio) {
          if ("" != this.codigo_bloco) {
            params.bloco = this.codigo_bloco;
          }
          if ("" != this.codigo_unidade) {
            params.codigo_unidade = +this.codigo_unidade;
          }
        }

        params.tipo_relacao = this.tipo_relacao;
        params.ano = this.ano;
        params.mes = this.mes;

        let {
          data: {
            DOCs: docs,
            Resumo: resumo,
            DadosCondominio: dadosCondominio,
          },
        } = await api.get(
          `/condominios/${this.codigo_condominio}/relatorio-docs`,
          {
            params,
          }
        );

        this.docs = docs;
        this.resumo = resumo;
        this.dadosCondominio = dadosCondominio;
      } catch (err) {
        this.errors = [...this.errors, err];
        console.error(err);
      }
    },
    async loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errors = [];
      await this.loadDocsCondominio();
      this.loading = false;
    },
  },
  watch: {
    codigo_condominio: {
      immediate: true,
      handler() {
        this.codigo_bloco = "";
        this.codigo_unidade = "";
        this.loadData();
      },
    },
    tipo_relacao: {
      immediate: true,
      handler() {
        this.loadData();
      },
    },
    codigo_bloco() {
      this.codigo_unidade = "";
    },
    sistema: {
      immediate: true,
      handler() {
        this.loadData();
      },
    },
  },
};
</script>
<style lang="less">
table {
  &.table-docs {
    tr {
      background-color: #f3f3f3;
    }
  }

  &.table-values {
    tr {
      border: 1px solid #ffffff;

      td {
        @media (max-width: 40em) {
          max-width: 90px;
          font-size: 11px;
          padding: 3px;
        }

        @media (max-width: 24em) {
          max-width: 73px;
        }
      }
    }
  }
}
</style>
